import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../hooks/store-hooks";
import {
  useDeletePostMutation,
  useLazyGetHomeDataQuery,
} from "../../../../store/api/homeApi";
import { addPostData } from "../../../../store/slices/homeSlice";
import { closeModal } from "../../../../store/slices/modalSlice";
import Button from "../../../common/button";
import Modal from "../../../common/modals";
import { toastError, toastSuccess } from "../../../toast";
import { getLocalStorage } from "../../../../helpers/storage";

interface DeletePostProps {
  activityId?: string | undefined;
}

const DeletePost: React.FC<DeletePostProps> = ({ activityId }) => {
  const navigate = useNavigate();
  const user = JSON.parse(getLocalStorage("userData") || "{}");
  const [trigger] = useLazyGetHomeDataQuery();

  const dispatch = useAppDispatch();
  const [deletePost, { isLoading }] = useDeletePostMutation();
  const { modalData: postId } = useAppSelector((state) => state.modal || {});
  const handleDelete = async () => {
    try {
      const response = await deletePost(postId).unwrap();
      if (response?.success) {
        if (activityId) {
          navigate(`/home/user/${user?._id}`);
        }
        toastSuccess({ message: response?.data?.messsage });
        const getResponse = await trigger().unwrap();
        if (getResponse?.success) {
          dispatch(addPostData({ ...getResponse.data, isReset: true }));
        }
      } else {
        toastError({ message: response?.error?.messsage });
      }
    } catch (error) {
      console.log(error);
      toastError({ message: "Something went wrong" });
    }
    dispatch(closeModal());
  };

  return (
    <Modal size="small" isOpen={true}>
      <div className="bg-white rounded-xl mx-3">
        <div className=" w-full flex flex-col items-center gap-4 border-b  p-4 pt-10">
          <div className="text-primary-900 text-[28px] font-bold leading-8 tracking-tight">
            Delete Post
          </div>
          <div className="text-center text-primary-900 text-base font-normal leading-5">
            Are you sure you want to delete this post? Once deleted it cannot be
            brought back.
          </div>
          <img src="/assets/delete-post.png" className="w-44 h-44" alt=""></img>
        </div>
        <div className="w-full flex gap-2 justify-end py-4">
          <Button
            variant="secondary"
            onClick={() => {
              dispatch(closeModal());
            }}
          >
            Cancel
          </Button>
          <Button
            isSubmitting={isLoading}
            variant="danger"
            onClick={() => {
              handleDelete();
            }}
          >
            Delete
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeletePost;
